import React, { Component, Fragment } from "react";
import Navbar from "../../Components/ProducaoEP/Realizado/UI/Navbar";
import UploadIndex from "../../Components/ProducaoEP/Realizado/Upload/Index/index";
import NomeUnidade from "../../Components/UI/NomeUnidade";

export default class PageUpload extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
    }

    componentDidMount() {
    }

    render() {
        return(
            <Fragment>

                {/*
                <div className="row mb-4">
                    <Navbar />
                </div>
                */}
                <NomeUnidade unidade={"Relatórios"}/>

                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <UploadIndex />
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}